import { useState } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { theme } from '@frontend/theme';
import { URLs } from '../../../constants';
import { trackingIds } from '../../../tracking-ids';
import { formatters } from '../../../utils';
import { ROIConversionChart } from '../charts';
import {
  AppointmentsScheduledDescription,
  Filters,
  Highlight,
  MessagesSentDescription,
  SummaryCards,
  SummaryCardsData,
} from '../components';
import { useROIShallowStore } from '../hooks';

// TODO :: update when API is ready
const dummySummaryCardData: SummaryCardsData[] = [
  {
    cardId: 'messagesSent',
    data: [
      {
        label: 'Messages Sent',
        value: 500,
      },
    ],
    subtitle: 'Jun 1 - Jun 30',
    title: 'Messages Sent',
    trackingId: trackingIds.roi.missedCallTextMessageSentCard,
  },
  {
    cardId: 'appointmentsScheduled',
    data: [
      {
        label: 'Appointments Scheduled',
        value: 444,
      },
    ],
    subtitle: 'Jun 1 - Jun 30',
    title: 'Appts Scheduled',
    trackingId: trackingIds.roi.missedCallTextAppointmentsScheduledCard,
  },
  {
    cardId: 'practiceValue',
    data: [
      {
        label: 'Appts Completed',
        value: 210,
      },
    ],
    noop: true,
    subtitle: 'Jun 1 - Jun 30',
    title: 'Practice Value',
    trackingId: trackingIds.roi.missedCallTextPracticeValueCard,
  },
];

export const MissedCallTextRoiPage = () => {
  const { t } = useTranslation('analytics');
  const [activeCardId, setActiveCardId] = useState<string>('messagesSent');
  const { filterHintText: subtitle } = useROIShallowStore('filterHintText');

  return (
    <Page>
      <Page.Header>
        <Page.Header.Breadcrumbs
          breadcrumbs={[
            {
              label: t('Analytics'),
              to: URLs.ANALYTICS_BASE,
            },
            {
              label: t('Messaging Analytics'),
              to: URLs.MESSAGING_ANALYTICS_BASE,
            },
            {
              label: t('Missed Call Text Conversion'),
            },
          ]}
        />
        <Page.Header.Heading>
          <Page.Header.Title title={t('Missed Call Text Conversion')} />
          <Page.Header.Subtitle subtitle={t('Showing results for {{subtitle}}', { subtitle })} />
        </Page.Header.Heading>
      </Page.Header>

      <Page.Body css={styles.body}>
        <div css={styles.body}>
          {/* TODO :: pass isLoding and amount props to the following components */}
          <Filters />
          <Highlight amount={40000} />
          <SummaryCards activeCardId={activeCardId} data={dummySummaryCardData} onClick={setActiveCardId} />
          <ROIConversionChart
            description={
              // TODO :: update the values when api is ready
              activeCardId === 'messagesSent' ? (
                <MessagesSentDescription
                  achievedValue={formatters.value.format(281)}
                  totalValue={formatters.value.format(500)}
                />
              ) : (
                <AppointmentsScheduledDescription
                  achievedValue={formatters.value.format(444)}
                  totalValue={formatters.value.format(610)}
                />
              )
            }
            subtitle={t('Missed call texts sent from')}
          />
        </div>
      </Page.Body>
    </Page>
  );
};

const styles = {
  body: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
